import React from 'react';

const AdditionalInformation = ({ productInfo }) => {
  if (!productInfo) return <div>No product information available.</div>;
  
  // Field configuration - easy to maintain and extend
  const fields = [
    { key: 'minExpectedUsers', label: 'Minimum Expected Users' },
    { key: 'maxExpectedUsers', label: 'Maximum Expected Users' },
    { key: 'valueMapping', label: 'Value Mapping' },
    { key: 'assetSource', label: 'Asset Source' },
    { 
      key: 'slaResponseTime', 
      label: 'SLA Response Time',
      specialRender: (value) => {
        if (!value) return 'N/A';
        return `${value.value} ${value.unit}`;
      }
    },
    { 
      key: 'slaUptime', 
      label: 'SLA Uptime',
      specialRender: (value) => {
        if (!value) return 'N/A';
        return `${value}%`;
      }
    },
    { 
      key: 'productDocumentationUrl', 
      label: 'Product Documentation URL',
      specialRender: (value) => {
        if (!value) return 'N/A';
        return (
          <a 
            href={value} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            {value}
          </a>
        );
      }
    }
  ];

  // Helper function to render a table row
  const renderField = (field) => {
    const value = productInfo[field.key];
    
    return (
      <tr key={field.key} className="hover:bg-gray-50 transition-colors">
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
          {field.label}
        </td>
        <td className="px-6 py-4 text-sm text-gray-700">
          {field.specialRender ? field.specialRender(value) : (value || 'N/A')}
        </td>
      </tr>
    );
  };
  
  return (
    <div>
      <h3 className="text-xl font-bold text-gray-800 mb-4">Additional Information</h3>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-[#FF31A0]">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Label</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Value</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {fields.map(renderField)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdditionalInformation; 